import { Navigate, useLocation } from 'react-router-dom';
import { isAdmin } from '../helpers';

/**
 * Requires a logged-in user with admin role (role >= 10).
 */
function AdminRoute({ children }) {
  const location = useLocation();
  if (!localStorage.getItem('user')) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (!isAdmin()) {
    return <Navigate to='/' replace />;
  }
  return children;
}

export { AdminRoute };
